import React from 'react';

/** Silhueta minimalista reconhecível do TikTok (monocromática). */
export function TikTokIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
      <path d="M19.321 5.562a5.122 5.122 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966 4.228 4.228 0 0 1-.665-1.016 3.49 3.49 0 0 1-.12-.293V2h-3.686v11.427a2.894 2.894 0 1 1-2.288-2.816 2.898 2.898 0 0 1 .892.137V8.697a6.338 6.338 0 1 0 5.183 6.209V8.418a8.2 8.2 0 0 0 4.824 1.556V6.424a4.831 4.831 0 0 1-1.06-.862z" />
    </svg>
  );
}

/** Árvore de links minimalista inspirada no Linktree (4 nós conectados). */
export function LinktreeIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden>
      <circle cx="12" cy="5" r="2.15" fill="currentColor" />
      <circle cx="6.25" cy="12.5" r="2.15" fill="currentColor" />
      <circle cx="17.75" cy="12.5" r="2.15" fill="currentColor" />
      <circle cx="12" cy="19.5" r="2.15" fill="currentColor" />
      <path
        d="M12 7.15v3.1M10.05 10.85 8.2 11.55M13.95 10.85l1.85.7M12 14.65v3.2"
        stroke="currentColor"
        strokeWidth="1.45"
        strokeLinecap="round"
      />
    </svg>
  );
}
